import React from 'react';
import {withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import logo from '../assets/img/logo.svg';
import Api from './../api/api';


// import logo from '../assets/img/logo.svg';


class Footer extends React.Component {

    state={
        email:'',
        newsletterSubscribed:false,
        data:''
    }

    onChangeEmail = (e) => {
        this.setState({email: e.target.value});
    }

    componentDidMount(){
        Api.getSocialMediaLinks().then((response)=>{
            this.setState({data:response.data})
        })
    }
    submitNewsletter = () => {
        const {email} = this.state;
        Api.postNewsletter({email}).then(()=>{
            localStorage["newsletterSubscribed"]= email;
            this.setState({newsletterSubscribed:true},()=>{
                setTimeout(()=>{
                    this.setState({newsletterSubscribed:false});
                }, 5000)
            });
        });
    }

    renderNewsLetter = () => {
        return(
            <div className="newsletter">
                <div className="newsletter-wrapper">
                    <p className="newsletter-text">Sign Up to Our Newsletter</p>
                    <div className="email">
                        <p className="cursor-pointer" onClick={()=>document.getElementById("email-input").focus()}>Email*</p>
                        <input id="email-input" value={this.state.email} onChange={(e)=>this.onChangeEmail(e)} type="text" />
                    </div>
                    <div className="btn-wrapper">
                        <input value="Sign Up" type="submit" className="btn" onClick={()=>{this.submitNewsletter()}}/>
                    </div>
                </div>
            </div>
        )
    }

    newsletterSubscribedAlert = () => {
        return(
            <div className="subscribed-alerts">
                <div>
                    <img src={logo} alt="logo" />
                    <p>Newsletter</p>
                </div>
                <p>Hi {localStorage["newsletterSubscribed"].split("@")[0]}, <br/>
                    Welcome to Cerafini. <br/>
                    Thank you for signing up to our newsletter.
                </p>
                <span>
                    We send periodic email updates on new collections and stories from our blog.
                </span>
            </div>
        )
    }

    render (){
        const {langTxt, langUrl} =this.props;
        const {newsletterSubscribed, data} =this.state;
       return (
            <>
            {(newsletterSubscribed)? this.newsletterSubscribedAlert() : ''}
            <footer className="footer">
                {(data)? 
                <>
                    {(newsletterSubscribed || localStorage["newsletterSubscribed"])? '':this.renderNewsLetter()}
                    <div className="footer-wrapper">
                        <div className="upper-footer">
                            <div>
                                <img src={logo} alt="logo"/>
                            </div>
                            <div className="upper-footer-right">
                                <div className="nav-social">
                                    <div className="nav-bar">
                                        <Link to={langUrl+"/collections"}>Collections</Link>
                                        <Link to={langUrl+"/blog"}>Blog</Link>
                                        <Link to={langUrl+"/about"}>About</Link>
                                    </div>
                                    <div className="social-media">
                                        <a href={data.facebook_link} without rel="noreferrer" target="_blank">FB</a>
                                        <a href={data.instagram_link}  without rel="noreferrer" target="_blank">IG</a>
                                        <a href={data.linkedIn_link} without rel="noreferrer" target="_blank">TW</a>
                                        <a href={data.youtube_link}  without rel="noreferrer" target="_blank">YT</a>
                                        <a href={data.twitter_link}  without rel="noreferrer" target="_blank">IN</a>
                                    </div>
                                </div>
                                {(langTxt === "en")? <a className="footer-lang-btn" href="/fr">Fr</a>: <a className="footer-lang-btn" href="/">En</a>}
                            </div>
                        </div>
                        <div className="lower-footer">
                            <div className="lower-footer-left">
                                <div className="company-details">
                                    <a href="https://goo.gl/maps/TeP2MMGpYBHfyksH8" without rel="noreferrer" target="_blank" className="company-details-address">
                                        <p >Via Mario Vellani Marchi 80 - 41124</p>
                                        <p>Modena, Italy</p>
                                    </a>
                                    <div className="company-details-contact">
                                        <a href="mailto:hello@cerafini.com" without rel="noreferrer" target="_blank">hello@cerafini.com</a>
                                        <a href="tel:+39 366 266 7588">T +39 366 266 7588</a>
                                    </div>
                                </div>
                            </div>
                            <div className="lower-footer-right">
                                <Link to={langUrl + "/faq"}>FAQ</Link>
                                <div className="policy-trademark">
                                    <div className="policy-wrapper">
                                        <Link to={langUrl+"/terms"}>T&C</Link>
                                        <Link to={langUrl+"/policy"}>Policy</Link>
                                    </div>
                                    <p className="trademark">© 2020</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>:''}
               
            </footer>
            </>
       );
    }
}

// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(Footer) );